import React, { useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import InputIncoterm from '@components/obsolete/Form/InputIncoterm/InputIncoterm.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  code: string;
  onChange: (code: string) => void;
  readOnly?: boolean;
  dataTestId?: string;
}

/** Code-based incoterm tag — SN stores a single deliveryConditionsIncotermCode (code-only by design),
 * distinct from the value+description IncotermsTag used by expeditions. */
const IncotermCodeTag: React.FC<ComponentProps> = ({ secured, code, onChange, readOnly, dataTestId }) => {
  const { tr } = useTranslationLgs();
  const [internalValue, setInternalValue] = useState(code);

  useEffect(() => setInternalValue(code), [code]);

  return (
    <ButtonTag
      secured={secured}
      label={tr('IncotermCodeTag.label', 'Incoterm')}
      value={internalValue}
      readonly={readOnly}
      onSave={onSuccess => {
        onChange(internalValue);
        onSuccess();
      }}
      popupWidth={'350px'}
      autoClose
      dataTestId={dataTestId}
    >
      <InputIncoterm code={internalValue} onChange={v => setInternalValue(v)} dataTestId={dataTestId ? `${dataTestId}-select` : undefined} />
    </ButtonTag>
  );
};

export default IncotermCodeTag;
